import api from "../api/flexapi";
import { showToast } from "actions/toastActions";

export const GET_DASHBOARD_NOTIFICATIONS = "GET_DASHBOARD_NOTIFICATIONS";
export const REMOVE_NOTIFICATION_BEGIN = "REMOVE_NOTIFICATION_BEGIN";
export const REMOVE_NOTIFICATION_REQUEST = "REMOVE_NOTIFICATION_REQUEST";
export const REMOVE_NOTIFICATION_FAILED = "REMOVE_NOTIFICATION_FAILED";

export const INIT_DASHBOARD_NOTIFICATIONS = "INIT_DASHBOARD_NOTIFICATIONS";

export const GET_EMPLOYEE_NOTIFICATIONS_SUCCESS = "GET_EMPLOYEE_NOTIFICATIONS_SUCCESS"
export const GET_EMPLOYEE_NOTIFICATIONS_FAIL = "GET_EMPLOYEE_NOTIFICATIONS_FAIL"

export const SET_NOTIFICATIONS_READ_SUCCESS = "SET_NOTIFICATIONS_READ_SUCCESS"
export const SET_NOTIFICATIONS_READ_ERROR = "SET_NOTIFICATIONS_READ_ERROR"

export function initNotificationsWidget(dashboardProps) {
  // Return thunk middleware
  return dispatch => {
    dispatch({ type: GET_DASHBOARD_NOTIFICATIONS, payload: dashboardProps });
  };
}

export const initNotificationsWidgetNew = notifications => ({
  type: INIT_DASHBOARD_NOTIFICATIONS,
  payload: notifications,
});

export function removeNotificationsById(notificationType) {
  const a = dispatch => {
    dispatch({ type: REMOVE_NOTIFICATION_BEGIN, payload: notificationType });

    return api
      .ackNotification({ notificationType })
      .then(response => {
        dispatch({
          type: REMOVE_NOTIFICATION_REQUEST,
          payload: notificationType,
        });
        dispatch(showToast({ message: `${response}` }));
      })
      .catch(err => {
        const errorMessage = err && err.response ? err.response.body : err;
        dispatch({
          type: REMOVE_NOTIFICATION_FAILED,
          payload: errorMessage,
        });
        dispatch(showToast({ message: errorMessage }));
        throw new Error(err);
      });
  };
  return a;
}

export const getEmployeeNotifications = (count, page, pageSize) => dispatch => {
  api
  .getEmployeeNotifications(count, page, pageSize)
  .then(response => {
    dispatch({
      type: GET_EMPLOYEE_NOTIFICATIONS_SUCCESS,
      payload: { ...response.body },
    });
  })
  .catch(err => {
    dispatch({
      type: GET_EMPLOYEE_NOTIFICATIONS_FAIL,
      payload: err.response ? err.response.body : err,
    });
  });
}

export const setNotificationsRead = (id) => dispatch => {
  api
  .setNotificationsRead(id)
  .then(response => {
    dispatch({
      type: SET_NOTIFICATIONS_READ_SUCCESS,
      payload: { ...response.body },
    });
  })
  .catch(err => {
    dispatch({
      type: SET_NOTIFICATIONS_READ_ERROR,
      payload: err.response ? err.response.body : err,
    });
  });
}


// WEBPACK FOOTER //
// ./actions/notificationActions.jsx